var PLACEMENTS = {
    SHOW_ON_HOVER: 'SHOW_ON_HOVER',
    SHOW_BELOW: 'SHOW_BELOW',
    SHOW_ABOVE: 'SHOW_ABOVE',
    SHOW_ON_THE_RIGHT: 'SHOW_ON_THE_RIGHT',
    SHOW_ON_THE_LEFT: 'SHOW_ON_THE_LEFT',
    ALTERNATE_HORIZONTAL: 'ALTERNATE_HORIZONTAL',
    ALTERNATE_VERTICAL: 'ALTERNATE_VERTICAL',
};
var hasHoverPlacement = function (placement) {
    return String(placement).indexOf(PLACEMENTS.SHOW_ON_HOVER) >= 0;
};
var hasAbovePlacement = function (placement, idx) {
    return String(placement).indexOf(PLACEMENTS.SHOW_ABOVE) >= 0 ||
        (idx % 2 === 0 &&
            String(placement).indexOf(PLACEMENTS.ALTERNATE_VERTICAL) >= 0);
};
var hasBelowPlacement = function (placement, idx) {
    return String(placement).indexOf(PLACEMENTS.SHOW_BELOW) >= 0 ||
        (idx % 2 === 1 &&
            String(placement).indexOf(PLACEMENTS.ALTERNATE_VERTICAL) >= 0);
};
var hasRightPlacement = function (placement, idx) {
    return String(placement).indexOf(PLACEMENTS.SHOW_ON_THE_RIGHT) >= 0 ||
        (idx % 2 === 0 &&
            String(placement).indexOf(PLACEMENTS.ALTERNATE_HORIZONTAL) >= 0);
};
var hasLeftPlacement = function (placement, idx) {
    return String(placement).indexOf(PLACEMENTS.SHOW_ON_THE_LEFT) >= 0 ||
        (idx % 2 === 1 &&
            String(placement).indexOf(PLACEMENTS.ALTERNATE_HORIZONTAL) >= 0);
};
var hasVerticalPlacement = function (placement) {
    return hasAbovePlacement(placement, 0) || hasBelowPlacement(placement, 1);
};
var hasHorizontalPlacement = function (placement) {
    return hasRightPlacement(placement, 0) || hasLeftPlacement(placement, 1);
};
var isVerticalPlacement = function (placement) {
    return hasVerticalPlacement(placement) &&
        !hasHorizontalPlacement(placement) &&
        !hasHoverPlacement(placement);
};
var isHorizontalPlacement = function (placement) {
    return hasHorizontalPlacement(placement) &&
        !hasVerticalPlacement(placement) &&
        !hasHoverPlacement(placement);
};
var isAbovePlacement = function (placement) {
    return String(placement) === PLACEMENTS.SHOW_ABOVE;
};
var isBelowPlacement = function (placement) {
    return String(placement) === PLACEMENTS.SHOW_BELOW;
};
var isHoverPlacement = function (placement) {
    return String(placement) === PLACEMENTS.SHOW_ON_HOVER;
};
var isRightPlacement = function (placement) {
    return String(placement) === PLACEMENTS.SHOW_ON_THE_RIGHT;
};
var isLeftPlacement = function (placement) {
    return String(placement) === PLACEMENTS.SHOW_ON_THE_LEFT;
};
export default PLACEMENTS;
export { hasAbovePlacement, hasBelowPlacement, hasHoverPlacement, hasRightPlacement, hasLeftPlacement, hasVerticalPlacement, hasHorizontalPlacement, isAbovePlacement, isBelowPlacement, isHoverPlacement, isRightPlacement, isLeftPlacement, isVerticalPlacement, isHorizontalPlacement, };
//# sourceMappingURL=placements.js.map